// src/admin/hooks/useAdminTaskReports.js

import { useEffect, useState, useCallback } from 'react';
import useIsMounted from '../../shared/hooks/useIsMounted';
import { fetchWithAuth } from '../auth/fetchWithAuth';
import { API_URL } from '../../config/env';

export function formatMonth(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  return `${y}-${m}`;
}

export function getPreviousMonth(yyyyMm) {
  if (!yyyyMm) return formatMonth(new Date());
  const [y, m] = yyyyMm.split('-').map(Number);
  const d = new Date(y, m - 2, 1); // previous month
  return formatMonth(d);
}

export function getNextMonth(yyyyMm) {
  if (!yyyyMm) return formatMonth(new Date());
  const [y, m] = yyyyMm.split('-').map(Number);
  const d = new Date(y, m, 1); // next month
  return formatMonth(d);
}

export default function useAdminTaskReports(month) {
  const isMounted = useIsMounted();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchIt = useCallback(async () => {
    if (!month) return;
    setLoading(true);
    try {
      const url = `${API_URL}/v1/admin/reporting/tasks?month=${encodeURIComponent(month)}`;
      const res = await fetchWithAuth(url, { cache: 'no-store' });
      if (!res.ok) throw new Error(res.statusText || 'Failed to load reports');
      const json = await res.json();
      setData(Array.isArray(json) ? json : []);
      setError(null);
    } catch (err) {
      if (!isMounted.current) return;
      console.error('Failed to fetch task reports', err);
      setData([]);
      setError(err);
    } finally {
      if (!isMounted.current) return;
      setLoading(false);
    }
  }, [month, isMounted]);

  useEffect(() => { fetchIt(); }, [fetchIt]);

  return { data, loading, error, refresh: fetchIt };
}
